import React, { useState, useEffect } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
 
import { dialogTheme, DialogWrapper, TypeIcon, DialogIcon } from "./css";
const Types = ["info", "success", "error", "warn"];

const BaseDailog = (props) => {
  const {
    type,
    title,
    content,
    okText,
    cancelText,
    onOk,
    onCancel,
    noOk,
    noCancel,

    isMobile = false,
    // React Components props
    notFunction = false,
    noClose = false,
    dialogClass = '',
    children,
    show,
    setShow,
  } = props;

  // not function: Modal({...})
  const isReactComponent = children || notFunction
  const [isOpen, setOpen] = useState(true);
  const [okLoading, setOkLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const defalutCancelFn = () => (isReactComponent ? setShow : setOpen)(false);
  const onCancelFn = async () => {
    if (typeof onCancel === "function") {
      try {
        setCancelLoading(true);
        const cancelEnd = await onCancel();
        setCancelLoading(false);
        if (cancelEnd) {
          defalutCancelFn();
        }
      } catch (error) {
        //
      }
    } else {
      defalutCancelFn();
    }
  };

  const onOkFn = async () => {
    if (typeof onOk === "function") {
      try {
        setOkLoading(true);
        const okEnd = await onOk();
        setOkLoading(false);
        if (okEnd) {
          defalutCancelFn();
        }
      } catch (error) {
        //
      }
    } else {
      defalutCancelFn();
    }
  };

  // fix the modal `Save the email as draft?` block failed problem when leave the compose and click in modal empty area.
  const onClick = (ev) => {
    ev.stopPropagation()
    // ev.preventDefault()
  }

  const escEvent = (ev) => {
    if (ev.key.toLowerCase() === 'escape') {
      defalutCancelFn();
    }
  }

  useEffect(() => {
    document.body.addEventListener('keydown', escEvent)

    return () => {
      document.body.removeEventListener('keydown', escEvent)
    }
  }, [escEvent])

  const clickBlankClosePop = (ev) => {
    if (ev.target.classList.contains('MuiBackdrop-root')) {
      defalutCancelFn();
    }
  }
  useEffect(() => {
    if (noClose) {
      return
    }
    document.body.addEventListener('click', clickBlankClosePop)

    return () => {
      document.body.removeEventListener('click', clickBlankClosePop)
    }
  }, [noClose])

  return (
    <ThemeProvider theme={dialogTheme}>
      <DialogWrapper
        open={isReactComponent ? show : isOpen}
        onClose={onCancel}
        onClick={onClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`dialog ${dialogClass} ${isMobile ? 'mobile-dialog' : ''}`}
        sx={{ m: 3, p: 3 }}
      >
        {!noClose && (<div className="closeicon">
          <CloseIcon onClick={defalutCancelFn}></CloseIcon>
        </div>
        )}
        {Types.includes(type) ? <DialogIcon><TypeIcon className={`${type}`} size="46"></TypeIcon></DialogIcon> : null}
        {title && (
          <DialogTitle className="title">
            {title}
          </DialogTitle>
        )}

        {children && (
          <DialogContent
            className={title ? "" : "no-title"}
          >
            {children}
          </DialogContent>
        )}

        {!children && content && (
          <DialogContent
            className={title ? "" : "no-title"}
            dangerouslySetInnerHTML={{ __html: content }}
          >
          </DialogContent>
        )}

        {noOk && noCancel ? null : (
          <DialogActions>
            {!noCancel && (
              <LoadingButton
                size="small"
                onClick={onCancelFn}
                loadingPosition="start"
                startIcon={cancelLoading ? <CircularProgress size={16} /> : <></>}
                loading={cancelLoading}
                variant="outlined"
              >
                {cancelText || "Cancel"}
              </LoadingButton>
            )}
            {!noOk && (
              <LoadingButton
                size="small"
                onClick={onOkFn}
                loading={okLoading}
                startIcon={okLoading ? <CircularProgress size={16} /> : <></>}
                loadingPosition="start"
                variant="contained"
              >
                {okText || "Confirm"}
              </LoadingButton>
            )}
          </DialogActions>
        )}
      </DialogWrapper>
    </ThemeProvider>
  );
};

export default BaseDailog;
